import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
const getChangePswdUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/change-consumer-password`;

// Actions
const changePasswordRequested = () => ({
    type: types.CHANGE_PASSWORD_REQUEST
  });

const changePasswordSuccess = data => ({
    type: types.CHANGE_PASSWORD_SUCCESS,
    data
  });
    
const changePasswordFailure = error => ({
    type: types.CHANGE_PASSWORD_FAILURE,
    error
  });

// API
export const updatePassword = (options) => {
    return dispatch => {
      dispatch(changePasswordRequested());
      // 
      axios.put(getChangePswdUrl, options, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //'Content-Type': 'application/json; charset=UTF-8'
          },
      })
        .then(res => {
          if (res.data.ack === "Success") {
            dispatch(changePasswordSuccess(res.data.results));
            toast.success(`Password has been changed! Please login`);
          } else if (res.data.ack === "Failure") {
            toast.error(`Failed - ${res.data.status.message}`);
            dispatch(changePasswordFailure(res.data.status));
          } 
        })
        .catch(err => {
            throw err;
          // dispatch(addTodoFailure(err.message));
        });
    };
  };